export type FileTypes = "unknown" | "any" | "image" | "pdf" | "docx" | "jpg" | "png" | "bmp";

export const formatBytes = (bytes: number, decimals = 0) => {
  if (bytes === 0) return "0 Bytes";

  const k = 1024;
  const dm = decimals < 0 ? 0 : decimals;
  const sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];

  const i = Math.floor(Math.log(bytes) / Math.log(k));

  return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + " " + sizes[i];
};

export const bytesToMb = (bytes: number): number => {
  return bytes / 1024 / 1024;
};

export const fileExtensionMap: { [type in FileTypes]: string } = {
  bmp: ".bmp",
  jpg: ".jpg",
  png: ".png",
  image: ".jpg, .png",
  pdf: ".pdf",
  docx: ".docx",
  any: "any",
  unknown: "unknown"
};

const isFileDto = (file: File | server.dto.File): file is server.dto.File => {
  return (file as server.dto.File).id !== undefined;
};

export const checkFileType = (file: File | server.dto.File, expectedType: FileTypes): boolean => {
  if (expectedType === "any") return true;

  const mimeType = isFileDto(file) ? getMimeType(file) : file.type;

  const isJpg = mimeType === "image/jpeg";
  const isPng = mimeType === "image/png";
  const isBmp = mimeType === "image/bmp";
  const isPdf = mimeType === "application/pdf";
  const isDocx = mimeType === "application/vnd.openxmlformats-officedocument.wordprocessingml.document";

  switch (expectedType) {
    case "bmp": return isBmp;
    case "pdf": return isPdf;
    case "docx": return isDocx;
    case "image": return isJpg || isPng || isBmp;
    case "png": return isPng;
    case "jpg": return isJpg;

    default: return false;
  }
};

export const getMimeType = (file: server.dto.File) => {
  if (file.extension === "bmp") return "image/bmp";
  if (file.extension === "pdf") return "application/pdf";
  if (file.extension === "docx") return "application/vnd.openxmlformats-officedocument.wordprocessingml.document";
  if (file.extension === "jpg") return "image/jpeg";
  if (file.extension === "png") return "image/png";
  return "unknown";
};
